import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import Select from 'react-select'

import ContentHeader from 'component/utils/ContentHeader'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Pagination from 'component/pagination/Pagination'

import SideFilterForm from 'component/datasheetManagementNew/SideFilterForm'
import Table from 'component/datasheetManagementNew/Table'
import Modal, { MODAL_TYPE } from 'component/datasheetManagementNew/Modal'
import SuccessModal from 'component/Modal/SuccessModal'
import ErrorModal from 'component/Modal/ErrorModal'
import * as reportActions from 'action/report'
import * as datasheetManagementActions from 'action/datasheetManagement'
import * as datasheetFormatActions from 'action/datasheetFormat'
import * as spinnerActions from 'action/spinner'
import { colourStyles } from 'utils/selectStyle'
import DownloadIconSVG from 'component/svgComponents/download'
import FilterIconSVG from 'component/svgComponents/filter'
import Button from 'component/Button'
import GenericModal from 'component/Modal/GenericModal'
import { hasEmptyProperties } from 'utils/validations'

const DEFAULT_STATE = {
  sectionId: '',
  subSectionId: '',
  typeId: '',
  subTypeId: '',
  idDatasheetFormatList: '',
}

const PAGINATION_OPTIONS = [
  { label: '05', value: 5 },
  { label: '10', value: 10 },
  { label: '20', value: 20 },
  { label: '30', value: 30 },
  { label: '40', value: 40 },
  { label: '50', value: 50 },
]

let signalController;

class DatasheetManagement extends PureComponent {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    clearSuccessMessage: PropTypes.func.isRequired,
    count: PropTypes.number,
    current: PropTypes.number,
    datasheetFormatList: PropTypes.array,
    datasheetManagementList: PropTypes.array.isRequired,
    datasheetManagementModel: PropTypes.object,
    deleteDatasheetManagement: PropTypes.func.isRequired,
    error: PropTypes.object,
    hideSpinner: PropTypes.func.isRequired,
    listDatasheetFormat: PropTypes.func.isRequired,
    listDatasheetManagement: PropTypes.func.isRequired,
    listDatasheetManagementFlux: PropTypes.func,
    pages: PropTypes.object,
    saveDatasheetManagement: PropTypes.func.isRequired,
    showSpinner: PropTypes.func.isRequired,
    success: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
    errorType: PropTypes.string,
    filterListDatasheetManagementFlux: PropTypes.func,
    clearError: PropTypes.func,
    getSections: PropTypes.func,
    fetchFluxReport: PropTypes.func.isRequired,
    allDatasheetList: PropTypes.array.isRequired
  }

  constructor() {
    super()

    this.state = {
      modalType: null,
      modalItem: null,
      sectionIdNm: '',
      subSectionIdNm: '',
      typeIdNm: '',
      subTypeIdNm: '',
      editExisting: false,
      showFilter: false,
      filterValues: DEFAULT_STATE,
      pagination: {
        page: 1,
        size: 5,
      },
      modalSuccess: {
        render: false,
        type: null,
      },
      modalError: {
        render: false,
        type: null,
      },
      modalExistentItem: {
        render: false,
        item: DEFAULT_STATE,
      },
      sections: { 2: [], 3: [], 4: [], 5: [] }
    }
  }

  componentDidMount() {
    const {
      auth: {
        user: { dsToken },
      },
      listDatasheetFormat,
      listDatasheetManagementFlux
    } = this.props
    const {
      pagination: { page, size },
    } = this.state

    signalController = new AbortController();

    listDatasheetFormat(dsToken, signalController)
  
    listDatasheetManagementFlux(dsToken, page, size, signalController)
  }

  renderExistent = () => {
    const { datasheetManagementModel } = this.props

    this.setState({
      modalExistentItem: { render: true, item: datasheetManagementModel },
    })
  }

  renderSuccess = (success) => {
    if (success === 'datasheetManagement.save.success') {
      this.setState({
        modalSuccess: { render: true, type: MODAL_TYPE.CREATE },
      })
    } else if (success === 'datasheetManagement.delete.success') {
      this.setState({
        modalSuccess: { render: true, type: MODAL_TYPE.DELETE },
      })
    }
  }

  renderError = (type) => {
    if (type === 'save') {
      this.setState({
        modalError: { render: true, type: MODAL_TYPE.CREATE },
      })
    } else if (type === 'delete') {
      this.setState({
        modalError: { render: true, type: MODAL_TYPE.DELETE },
      })
    }
  }

  componentDidUpdate(prevProps) {
    const {
      datasheetManagementModel,
      success,
      clearSuccessMessage,
      error,
      errorType,
      clearError,
      datasheetManagementList,
      getSections,
      auth: { user }
    } = this.props

    if (datasheetManagementList !== prevProps.datasheetManagementList) {
      getSections(user.dsToken, datasheetManagementList, sections => this.setState({ sections }))
    }

    if (success !== prevProps.success && success) {
      if (
        datasheetManagementModel !== prevProps.datasheetManagementModel &&
        Object.getOwnPropertyNames(datasheetManagementModel).length > 0
      ) {
        this.renderExistent()
      } else {
        this.renderSuccess(success)
      }
      clearSuccessMessage()
    }

    if (error !== prevProps.error && error) {
      this.renderError(errorType)
      clearError()
    }

  }

  openModal = (modalType, modalItem) => {
    this.setState({ modalType, modalItem })
  }

  editModal = () => {
    const { datasheetManagementModel } = this.props

    this.openModal(MODAL_TYPE.EDIT, datasheetManagementModel)
  }

  getPage = (page) => {
    const {
      auth: {
        user: { dsToken },
      },
      listDatasheetManagementFlux,
      filterListDatasheetManagementFlux

    } = this.props

    const { pagination, filterValues } = this.state

    const pageNumber = typeof page === 'object' && page.page ? page.page : page;

    this.setState({
      pagination: { ...pagination, page: pageNumber },
    });

    signalController = new AbortController();

    if (hasEmptyProperties(filterValues))
      listDatasheetManagementFlux(dsToken, pageNumber, pagination.size, signalController)

    else {
      const {
        sectionId,
        subSectionId,
        typeId,
        subTypeId,
        idDatasheetFormatList,
      } = filterValues

      filterListDatasheetManagementFlux(dsToken, pageNumber, pagination.size, {
        sectionId: typeof sectionId === 'string' ? null : sectionId,
        subSectionId: typeof subSectionId === 'string' ? null : subSectionId,
        typeId: typeof typeId === 'string' ? null : typeId,
        subTypeId: typeof subTypeId === 'string' ? null : subTypeId,
        format: idDatasheetFormatList
          ? idDatasheetFormatList.map((format) => format.value)
          : [],
      }, signalController)
    }
  }

  getSize = (size) => {
    const {
      auth: {
        user: { dsToken },
      },
      listDatasheetManagementFlux,
      filterListDatasheetManagementFlux,

    } = this.props
    const { filterValues } = this.state

    this.setState({
      pagination: { page: 1, size },
    })

    signalController = new AbortController();

    if (hasEmptyProperties(filterValues))
      listDatasheetManagementFlux(dsToken, 1, size, signalController)

    else {
      const {
        sectionId,
        subSectionId,
        typeId,
        subTypeId,
        idDatasheetFormatList,
      } = filterValues

      filterListDatasheetManagementFlux(dsToken, 1, size, {
        sectionId: typeof sectionId === 'string' ? null : sectionId,
        subSectionId: typeof subSectionId === 'string' ? null : subSectionId,
        typeId: typeof typeId === 'string' ? null : typeId,
        subTypeId: typeof subTypeId === 'string' ? null : subTypeId,
        format: idDatasheetFormatList
          ? idDatasheetFormatList.map((format) => format.value)
          : [],
      }, signalController)
    }
  }

  renderModal = () => {
    const {
      translate,
      auth: { user },
      datasheetFormatList,
    } = this.props

    const { modalType, modalItem, sections } = this.state

    return (
      <Modal
        closeModal={this.closeModal}
        handleDelete={this.handleDelete}
        handleSave={this.handleSave}
        modalItem={modalItem}
        modalType={modalType}
        translate={translate}
        sections={sections}
        user={user}
        datasheetFormatList={datasheetFormatList.flat?.() || []}
      />
    )
  }

  handleSave = (values) => {
    const {
      auth: {
        user: { dsToken },
      },
      saveDatasheetManagement,
    } = this.props
    const {
      pagination: { page, size },
      filterValues,
    } = this.state

    this.closeModal()

    saveDatasheetManagement(dsToken, values, page, size, filterValues)
  }

  handleDelete = (dm) => {
    const {
      auth: {
        user: { dsToken },
      },
      deleteDatasheetManagement,
      filterListDatasheetManagementFlux
    } = this.props
    const {
      pagination: { page, size },
      filterValues,
    } = this.state

    const signalController = new AbortController()

    this.closeModal()

    deleteDatasheetManagement(dsToken, dm, page, size, filterValues)
    .then(() => {
      filterListDatasheetManagementFlux(dsToken, page, size, filterValues, signalController)
        .then((res) => {
          const totalPages = res?.pages?.pageCount
          const totalCount = res?.pages?.totalCount

          // If there are no more records, go back to page 1
          if (totalCount === 0) {
            this.setState({
              pagination: {
                ...this.state.pagination,
                page: 1,
              },
            }, () => {
              filterListDatasheetManagementFlux(dsToken, 1, size, filterValues, new AbortController())
            })
          }

          // If the current page has become larger than the total pages
          else if (page > totalPages) {
            this.setState({
              pagination: {
                ...this.state.pagination,
                page: totalPages,
              },
            }, () => {
              filterListDatasheetManagementFlux(dsToken, totalPages, size, filterValues, new AbortController())
            })
          }
        })
    })
    .catch((error) => {
      console.error('Erro ao deletar item:', error)
    })
  }

  closeModal = () => {
    this.setState({ modalType: null })
  }

  handleFilter = (params) => {
    const {
      filterListDatasheetManagementFlux,
      auth: { user },
    } = this.props
    const {
      pagination: { size },
    } = this.state

    this.setSideFilterVisible(params)

    const {
      sectionId,
      subSectionId,
      typeId,
      subTypeId,
      idDatasheetFormatList,
    } = params

    filterListDatasheetManagementFlux(user.dsToken, 1, size, {
      sectionId: typeof sectionId === 'string' ? null : sectionId,
      subSectionId: typeof subSectionId === 'string' ? null : subSectionId,
      typeId: typeof typeId === 'string' ? null : typeId,
      subTypeId: typeof subTypeId === 'string' ? null : subTypeId,
      format: idDatasheetFormatList
        ? idDatasheetFormatList.map((format) => format.value)
        : [],
    }, signalController)
  }

  renderModalSuccess = () => {
    const {
      translate,
      listDatasheetManagementFlux,
      filterListDatasheetManagementFlux,
      auth: { user },
    } = this.props
    const {
      modalSuccess,
      pagination: { page, size },
      filterValues,
    } = this.state

    return (
      <SuccessModal
        size='sm'
        handleClose={() =>
          this.setState(
            {
              modalSuccess: {
                render: false,
                type: null,
              },
            },
            () => {
              if (hasEmptyProperties(filterValues))
                listDatasheetManagementFlux(user.dsToken, page, size, signalController)

              else {
                const {
                  sectionId,
                  subSectionId,
                  typeId,
                  subTypeId,
                  idDatasheetFormatList,
                } = filterValues


                filterListDatasheetManagementFlux(user.dsToken, page, size, {
                  sectionId: typeof sectionId === 'string' ? null : sectionId,
                  subSectionId:
                    typeof subSectionId === 'string' ? null : subSectionId,
                  typeId: typeof typeId === 'string' ? null : typeId,
                  subTypeId: typeof subTypeId === 'string' ? null : subTypeId,
                  format: idDatasheetFormatList
                    ? idDatasheetFormatList.map((format) => format.value)
                    : [],
                }, signalController)
              }
            }
          )
        }
        msg={
          modalSuccess.type &&
          (modalSuccess.type === MODAL_TYPE.CREATE
            ? translate('datasheetManagement.save.success.msg')
            : translate('datasheetManagement.delete.success.msg'))
        }
        t={translate}
        center
        buttonText='OK'
      />
    )
  }

  renderModalError = () => {
    const { translate } = this.props
    const { modalError } = this.state

    return (
      <ErrorModal
        size='sm'
        handleClose={() =>
          this.setState({
            modalError: {
              render: false,
              type: null,
            },
          })
        }
        msg={
          modalError.type &&
          (modalError.type === MODAL_TYPE.CREATE
            ? translate('datasheetManagement.save.error.msg')
            : translate('datasheetManagement.delete.error.msg'))
        }
        t={translate}
        center
        buttonText={translate('newLogin.errorModal.button.label')}
      />
    )
  }

  renderExistentItemModal = () => {
    const { modalExistentItem } = this.state
    const { translate } = this.props

    return (
      <GenericModal
        title={translate('datasheetManagement.save.already.existent.title')}
        size='md'
        isOpen
        onCloseModal={() =>
          this.setState({
            modalExistentItem: {
              render: false,
              item: DEFAULT_STATE,
            },
          })
        }
        disabledBgClickClosing
        buttonClass='new-login-error-modal-button'
        cancelButtonText={translate('close_button_label')}
        showFooter={false}
        renderButton={false}
        center
        confirmButtonText={translate('save_button_label')}
      >
        <div className='remove-modal no-padding'>
          <span className='title text-left margin-top margin-bottom'>
            {translate('datasheetManagement.save.already.existent.msg')}
          </span>
          <span className='title text-left margin-bottom'>
            {translate(
              'datasheetManagement.save.already.existent.new.question'
            )}
          </span>
          <div className='button-row w-100'>
            <Button
              className='btn btn-secondary margin-right-small'
              text={translate(
                'datasheetManagement.save.already.existent.new.register'
              )}
              onClick={() => {
                this.setState({
                  modalExistentItem: {
                    render: false,
                    item: DEFAULT_STATE,
                  },
                })
                this.openModal(MODAL_TYPE.CREATE, DEFAULT_STATE)
              }}
            />
            <Button
              className='btn btn-primary margin-left-small'
              text={translate(
                'datasheetManagement.save.already.existent.see.existent'
              )}
              onClick={() => {
                this.setState({
                  modalExistentItem: {
                    render: false,
                    item: DEFAULT_STATE,
                  },
                })
                this.openModal(MODAL_TYPE.EDIT, modalExistentItem.item)
              }}
            />
          </div>
        </div>
      </GenericModal>
    )
  }

  onExport = async () => {
    
    const {fetchFluxReport, auth, allDatasheetList} = this.props

    const datasheet = {
      sectionId:[],
      subSectionId:[],
      typeId:[],
      subTypeId:[],
      ids:[],
      tpReport: 27
    }

    allDatasheetList.forEach(item => {
      // Fill the 'ids' field using the 'idDatasheetManagement' field
      datasheet.ids.push(item.idDatasheetManagement);
    
      // For the other fields, check if the value exists, if it does not exist, assign -1
      datasheet.sectionId.push(item.sectionId !== undefined ? item.sectionId : -1);
      datasheet.subSectionId.push(item.subSectionId !== undefined ? item.subSectionId : -1);
      datasheet.typeId.push(item.typeId !== undefined ? item.typeId : -1);
      datasheet.subTypeId.push(item.subTypeId !== undefined ? item.subTypeId : -1);
    });

    if(datasheet)
      await fetchFluxReport(
        auth.user.dsToken, 
        { tpReport: 27 }, 
        datasheet, 
        translate,
        signalController)
  }

  setSideFilterVisible = (values) =>
    this.setState({ showFilter: false, filterValues: values })

  render() {
    const {
      auth: { user },
      datasheetFormatList,
      datasheetManagementList,
      pages,
      translate,
    } = this.props

    const {
      modalType,
      showFilter,
      filterValues,
      pagination,
      modalSuccess,
      modalError,
      modalExistentItem,
      sections
    } = this.state

    const count = pages?.pageCount;
    const current = pages?.page;
    const page= pages?.pageCount;

    return (
      <>
        <ContentHeader>
          {translate('datasheetManagement.new.title')}
        </ContentHeader>

        <div className='new-style-filter margin-bottom'>
          <section className='container-fluid new-upper-container'>
            <div className='col-xs-12 col-md-12'>
              <div className='float-right'>
                <Button
                  className='btn btn-primary margin-right'
                  text={translate('datasheetManagement.new.format')}
                  onClick={() =>
                    this.openModal(MODAL_TYPE.CREATE, DEFAULT_STATE)
                  }
                />
                <Button
                  className='btn btn-secondary margin-right'
                  text={translate('commonReport.download')}
                  onClick={this.onExport}

                  svgIcon
                  svgComponent={<DownloadIconSVG className="download-svg-small svg-green" />}

                />
                <Button
                  className='btn btn-secondary'
                  text={translate('mobile.filter')}
                  onClick={() => this.setState({ showFilter: true })}

                  svgIcon
                  svgComponent={<FilterIconSVG className="margin-default-svg" newDesign={false} />}
                />
              </div>
            </div>
          </section>
        </div>

        <div className='no-margin col-xs-12 col-md-12 overflow-x-hidden'>
          {showFilter && (
            <SideFilterForm
              user={user}
              datasheetFormatList={datasheetFormatList.flat?.() || []}
              translate={translate}
              setSideFilterVisible={this.setSideFilterVisible}
              filterValues={filterValues}
              handleFilter={this.handleFilter}
            />
          )}

          {datasheetManagementList.length > 0 ? (
            <Row>
              <Col xs={12}>
                <Table
                  current={current}
                  datasheetManagementList={datasheetManagementList}
                  openModal={this.openModal}
                  translate={translate}
                  sections={sections}
                />
              </Col>
            </Row>
          ) : (
            <div>
              <Row>
                <Col xs={12}>
                  <div className='notification-warning padding'>
                    <span className='text-center'>
                      {translate('no.data.found')}
                    </span>
                  </div>
                </Col>
              </Row>
            </div>
          )}

          {pages?.pageCount > 1 && (
            <Row>
              <Col className='align-center margin-bottom margin-top new-style-pagination'>
                <Pagination
                  count={count}
                  current={current}
                  getPage={this.getPage}
                  pages={page}
                />
                <div className='datasheet-manager-pagination-size-selector'>
                  <Col xs={7}>{translate('pagination.size.selector')}</Col>
                  <Col xs={4}>
                    <Select
                      styles={colourStyles}
                      classNamePrefix='react-select'
                      onChange={(option) => this.getSize(option.value)}
                      options={PAGINATION_OPTIONS}
                      value={PAGINATION_OPTIONS.find(
                        (i) => i.value === pagination.size
                      )}
                      menuPlacement='top'
                    />
                  </Col>
                </div>
              </Col>
            </Row>
          )}

          {modalType && this.renderModal()}
          {modalSuccess.render && this.renderModalSuccess()}
          {modalError.render && this.renderModalError()}
          {modalExistentItem.render && this.renderExistentItemModal()}
        </div>
      </>
    )
  }
}

const mapStateToProps = ({ datasheetManagementReducer, datasheetFormatReducer }) => ({
  ...datasheetManagementReducer,
  ...datasheetFormatReducer,
  error: datasheetManagementReducer.error,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...datasheetManagementActions,
      ...datasheetFormatActions,
      ...spinnerActions,
      ...reportActions
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  translate(null, { wait: true, translateFuncName: 'translate' })(
    DatasheetManagement
  )
)

export { DatasheetManagement }
